import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import ArrayLabel from "../ArrayLabel/ArrayLabel";
import {Divider, Space} from "antd";

const Fundus = props => {
  const {data, isShow = true} = props;
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Đáy mắt:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data || {}).filter(
              key => data[key] && key != "show" && key != "Option"
            ),
            "Ghi chú"
          ).map(key => {
            if (
              key == "Bong võng mạc" ||
              key == "Dịch kính" ||
              key == "Mạch máu" ||
              key == "Quan sát" ||
              key == "Tổn thương đáy mắt" ||
              key == "Tỷ lệ C/D"
            ) {
              return (
                <>
                  {!checkEmptyObj(data[key]) && (
                    <div>
                      • {key}: {data[key]?.text1}{" "}
                      {data[key]?.text1 && data[key]?.text2 && "-"}{" "}
                      {data[key]?.text2}
                    </div>
                  )}
                </>
              );
            } else if (key == "Hoàng điểm") {
              return <ArrayLabel data={data[key]} name={key}></ArrayLabel>;
            } else {
              return <InfoItem label={key} value={data[key]} />;
            }
          })}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="Fundus">{!checkEmptyObj(data) && render()}</div>;
};
export default Fundus;
